import arraysEqualIgnoringOrder from './arraysEqualIgnoringOrder'

// const xs = { 'a': 1, 'b': 2 }
// const ys = { 'a': 1, 'b': 2, 'extra': 'e' }
// zipTwoObjectsBy(xs, ys, (x, y) => x + y)
export default function zipTwoObjectsBy (xs, ys, merge) {
  const xs_keys = Object.keys(xs)
  const ys_keys = Object.keys(ys)
  if (!arraysEqualIgnoringOrder(xs_keys, ys_keys)) { throw new Error(`${xs_keys} ${ys_keys}`) }

  const result = {}
  for (const key in xs) {
    if (!Object.prototype.hasOwnProperty.call(ys, key)) {
      throw new Error(`no key ${key} in ys ${ys}`)
    }
    result[key] = merge(xs[key], ys[key])
  }
  return result
}
